import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import ImageContainer from '../reusable/ImageContainer.js';
import { ForgeCard, ForgeScaffold } from '@tylertech/forge-react';
import { VIEW_MORE } from '../../static/keyWords.js';

const HomePageCard = ({ imgUrl, imgAlt, title, description, to }) => {
  return (
    <ForgeCard className="forge-card" key={title}>
      <ForgeScaffold>
        <div className="card-body" slot="body">
          <ImageContainer source={imgUrl} alt={imgAlt} customClasses={'dashboard-card-img '} />
          <div className="forge-card-header-container">
            <h3 className="forge-typography--heading4">{title}</h3>
          </div>
          <div>
            <p className="forge-typography--body1">{description}</p>
          </div>
        </div>
        <div slot="footer" className="forge-card-footer">
          <forge-button>
            <Link to={to || '/'} aria-label={`View more about ${title}`}>{VIEW_MORE}</Link>
          </forge-button>
        </div>
      </ForgeScaffold>
    </ForgeCard>
  );
};

HomePageCard.propTypes = {
  imgUrl: PropTypes.string.isRequired,
  imgAlt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  to: PropTypes.string,
};

export default HomePageCard;
